<template>
  <div
    class="addBridge"
    ref="addBridge"
    v-show="visible"
  >
    <h5>修改</h5>
    <a-form :model="formState">
      <a-row>
        <a-col :span="11">
          <a-form-item class="ipt">
            <p>产品名称</p>
            <a-input
              v-model:value="formState.productName"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>
          <a-form-item class="ipt">
            <p>产品型号</p>
            <a-input
              v-model:value="formState.model"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>
          <!-- <a-form-item class="ipt">
            <p>位置序号</p>
            <a-input
              v-model:value="formState.orderNum"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item> -->
          <a-form-item class="ipt">
            <p>生产单位</p>
            <a-input
              v-model:value="formState.generatingUnit"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>
        </a-col>
        <a-col
          :span="11"
          offset="2"
        >
          <a-form-item class="ipt">
            <p>设计单位</p>
            <a-input
              v-model:value="formState.designUnit"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>
          <a-form-item class="ipt">
            <p>规格</p>
            <a-input
              v-model:value="formState.specName"
              placeholder="请输入"
            >
            </a-input>
          </a-form-item>
          <a-form-item class="ipt">
            <p>产品类型</p>
            <a-select
              class="a-select"
              ref="select"
              placeholder="请选择"
              v-model:value="formState.type"
            >
              <a-select-option
                :value="item.id"
                v-for="(item, i) in typeList"
              >{{item.value}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="ipt">
            <p>产品安装图</p>
            <a-row>
              <a-col>
                <a-upload
                  list-type="picture-card"
                  v-model:file-list="fileList"
                  :customRequest="customRequest"
                  :beforeUpload="beforeUpload"
                  @preview="handlePreview"
                >
                  <div v-if="fileList.length < 1">
                    <loading-outlined v-if="loading"></loading-outlined>
                    <plus-outlined
                      v-else
                      :style="{color: '#aaa', fontSize: '32px'}"
                    ></plus-outlined>
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-col>
            </a-row>
            <a-row>
              <a-col class="hint2">* 图片大小不能超过20M <br /> * 目前仅支持 jpg png格式图片</a-col>
            </a-row>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item
        class="ipt a-btn"
        label="&nbsp;"
      >
        <a-button
          class="confirm"
          @click="handleOkMsg"
        >确定</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      :visible="previewVisible"
      :footer="null"
      @cancel="handleCancel"
    >
      <img
        alt="example"
        style="width: 100%"
        :src="previewImage"
      />
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src
import _global from '@/utils/global'
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons-vue';
import { alterProduct, upload } from "@/api/project/project.js";
export default {
  name: "AlterProduct",
  components: {
    PlusOutlined,
    LoadingOutlined,
  },
  data() {
    return {
      baseURL: _global.baseURL,
      visible: false,
      typeList: [
        {
          id: '1',
          value: '支座',
        },
        {
          id: '2',
          value: '导风屏障',
        },
        {
          id: '3',
          value: '阻尼器',
        }
      ],
      formState: {
        productName: '',    // 产品名称
        model: '',          // 型号
        orderNum: '',       // 排序
        generatingUnit: '', // 生成单位
        designUnit: '',     // 设计单位
        specName: '',       // 规格
        type: '',         // 类型
        productPhoto: '',   // 产品相片
      },
      fileList: [
        {
          uid: '-1',
          status: 'done',
          url: '',
        },
      ],
      loading: false,
      previewVisible: false
    }
  },
  props: ['present'],
  updated() {
    this.formState = this.present
    this.fileList[0].url = this.baseURL + this.formState.productPhoto
    this.previewImage = this.baseURL + this.formState.productPhoto
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    change(value) {
      console.log(value)
    },
    handleOkMsg() {
      console.log('this.formState', this.formState.productName)
      // this.visible = false
      alterProduct(this.formState).then(res => {
        if (res.code == 200) {
          this.$message.success(res.data);
          this.$emit('confirm')
        }
      }).catch(res => {
        console.log(res)
      });
    },
    handlePreview() {
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },
    customRequest(option) {
      console.log(option)
      // option.onProgress({ percent: 50 })
      getBase64(option.file, imageUrl => {
        // this.formState.productPhotoTemp = imageUrl;
        this.loading = false;
      });
      const formData = new FormData()
      const uploadDto = [{
        fileName: option.file.name,
        type: 1
      }]
      formData.append('files', option.file)
      formData.append('uploadDto', JSON.stringify(uploadDto))
      upload(formData).then(res => { //上传图片
        if (res.code == 200) {
          this.formState.productPhoto = res.data[0].filePath
          this.previewImage = this.baseURL + res.data[0].filePath
          option.onSuccess()
        }
      }).catch(res => {
        console.log(res)
      });
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!');
      }
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!');
      }
      return isJpgOrPng && isLt2M;
    },
  }
};
function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}
</script>
<style scoped>
.ant-form {
  margin-top: 30px;
  text-align: left;
}
.ipt p {
  line-height: 1.6;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #222;
}
.ipt span {
  color: #ff4444;
}
.ipt .hint {
  float: right;
}
.ipt input {
  height: 40px;
  background: #fefefe;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.ipt :deep() .ant-upload.ant-upload-select-picture-card {
  width: 110px;
  height: 110px;
  border-radius: 6px;
}
.ipt :deep() .ant-select-selector {
  height: 38px;
  border-radius: 6px;
}
.ipt :deep() .ant-calendar-picker {
  width: 100%;
}
.ipt :deep() .ant-calendar-picker-input {
  width: 100%;
  height: 40px;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selector {
  height: 40px;
  background: #fefefe;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.ant-select :deep() .ant-select-selection-item,
.ant-select :deep() .ant-select-selection-placeholder {
  height: 38px !important;
  line-height: 38px !important;
}
.sample {
  position: relative;
  width: 110px;
  height: 110px;
  background: #fff;
  border: 1px solid #dddddd;
  border-radius: 6px;
}
.sample img {
  width: 108px;
  height: 108px;
}
.sample span {
  position: absolute;
  left: 1px;
  bottom: 1px;
  width: 50px;
  height: 20px;
  text-align: center;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #fff;
  background: #000;
  opacity: 0.5;
  border-radius: 0px 6px 0px 6px;
}
.hint2 {
  font-size: 12px;
  font-family: PingFangSC;
  font-weight: 400;
  color: #aaa;
}
</style>